import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LoginRedirectProvider } from './components/LoginRedirectProvider';
import Header from './components/Header';
import Home from './pages/Home';
import CreateOrganization from './pages/CreateOrganization';
import ManageOrganizations from './pages/ManageOrganizations';
import EditOrganization from './pages/EditOrganization';
import Contact from './pages/Contact';
import AdminPage from './pages/AdminPage';
import ProtectedRoute from './components/ProtectedRoute';
import LoginRoute from './pages/LoginRedirect';

import './App.css';

function App() {
  return (
    <Router>
      <LoginRedirectProvider>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Home />} />
          <Route path="/create-organization" element={
            <ProtectedRoute>
              <CreateOrganization />
            </ProtectedRoute>
          } />
          <Route path="/manage-organizations" element={
            <ProtectedRoute>
              <ManageOrganizations />
            </ProtectedRoute>
          } />
          <Route path="/edit-organization/:id" element={
            <ProtectedRoute>
              <EditOrganization />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          } />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      </LoginRedirectProvider>
    </Router>
  );
}

export default App;